// When a song is released, set status to "released" and add its streaming URLs.
// Set featured to true for the single you want highlighted on the album page.
const worthyForSongTracks = [
  {
    slug: "intro",
    title: "Intro",
    description: "Placeholder: Add a note about how this opening track introduces the album.",
    status: "upcoming",
    featured: false,
    spotifyUrl: "",
    youtubeMusicUrl: "",
    appleMusicUrl: "",
  },
  {
    slug: "sweeter-song-psalm-96",
    title: "Sweeter Song (Psalm 96)",
    description: "This song is about singing and creation new songs for the Lord! They tend to get sweeter as we see God clearer and keep writing of His immense grace towards us. This song also grabs most of its words directly from Psalm 96!  ",
    status: "released",
    featured: true,
    spotifyUrl: "https://open.spotify.com/track/0ZdXml6Zs9qUpNPKqsKlKZ?si=2781b73c658b49ec",
    youtubeMusicUrl: "https://music.youtube.com/watch?v=X2XxpmuLQEU&si=jQvdRvtw3dyYycYj",
    appleMusicUrl: "https://music.apple.com/us/song/sweeter-song-psalm-96/6784943980",
  },
  {
    slug: "10000-reasons",
    title: "10,000 Reasons",
    description: "Placeholder: Add context about this song and its place on the album.",
    status: "upcoming",
    featured: false,
    spotifyUrl: "",
    youtubeMusicUrl: "",
    appleMusicUrl: "",
  },
  {
    slug: "so-ill-praise",
    title: "So I'll Praise",
    description: "Placeholder: Describe the heart or story behind this song.",
    status: "upcoming",
    featured: false,
    spotifyUrl: "",
    youtubeMusicUrl: "",
    appleMusicUrl: "",
  },
  {
    slug: "come-behold-the-wondrous-mystery",
    title: "Come Behold the Woundrous Mystery",
    description: "Placeholder: Add a short description of this song and its inspiration.",
    status: "upcoming",
    featured: false,
    spotifyUrl: "",
    youtubeMusicUrl: "",
    appleMusicUrl: "",
  },
  {
    slug: "you-are-unchanging",
    title: "You are Unchanging",
    description: "Placeholder: Share what you hope listeners take away from this song.",
    status: "upcoming",
    featured: false,
    spotifyUrl: "",
    youtubeMusicUrl: "",
    appleMusicUrl: "",
  },
  {
    slug: "build-my-life",
    title: "Build my Life",
    description: "Placeholder: Add a note about this song’s message or arrangement.",
    status: "upcoming",
    featured: false,
    spotifyUrl: "",
    youtubeMusicUrl: "",
    appleMusicUrl: "",
  },
];

export default worthyForSongTracks;
